import { useState } from "react";
import withLoader from "../../components/layouts/WithLoader"
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import Payement from "../../services/Payement";
import DataTableTraite from "../../ui/DataTableTraite";




const PayerTraite=({startLoading,stopLoading})=>{

const [ref, setRef] = useState("");
  const [availableTicket, setAvailableTicket] = useState([]);


  const onChangeRefHandler = (event) => {
    setRef(event.target.value);
  };
  const getProductInfos = () => {
    startLoading();
    Payement.findChequeTraiteByRef(getCurrentUserId(), ref)
      .then((response) => {
        if (response.data.success) {
          setAvailableTicket(response?.data?.success)
        }
      })
      .catch((error) => {
        // setOpenErrorAlert(true);
        // setErrorAlertText("Erreur : " + error);

      }).finally(() => {
        stopLoading();
      });;
  };
  const filterTableTicket = () => {
    if (availableTicket && availableTicket?.length > 0) {
      return <DataTableTraite tickets={availableTicket} />;
    }
  };
  return (

    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="card card-dark">
            <div class="card-body">
              <h5 class="card-title">Chercher taite par référence </h5>{" "}
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">

                    <div className="col-sm-6">
                      <label>Référence traite</label>
                      <input
                        onChange={onChangeRefHandler}
                        type="text"
                        required
                        id="inputClientCompany"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="col-sm-12  text-center">
                    <button
                      className="btn btn-dark"
                      onClick={getProductInfos}
                    >
                      Valider le choix
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">{filterTableTicket()}</div>
          </div>
        </div>
      </section>
      {/* {filterTableTicket()} */}
    </div>
  )






}
export default withLoader(PayerTraite)